import { Grid, TableCell, TableRow, Typography } from '@mui/material';
import { RoundProgress } from 'components/round-progress';
import { getRowIcon } from 'utils/helpers/fileCabinetHelpers';
import { convertBytes } from 'utils/helpers';
import { styles } from './styles';

interface IUploadListView {
  percent: number;
  name: string;
  mimeType: string;
  size: number;
}

export const UploadListView = ({ percent, name, mimeType, size }: IUploadListView) => {
  const Icon = getRowIcon('file', mimeType);

  return (
    <TableRow sx={styles.tableRow}>
      <TableCell sx={styles.tableCell} className="first">
        <Grid sx={styles.tableFirstCellContainer}>
          <Icon />
          <Typography>{name}</Typography>
        </Grid>
      </TableCell>
      <TableCell sx={styles.tableCell}>
        <Typography>-</Typography>
      </TableCell>
      <TableCell sx={styles.tableCell}>
        <Typography>{convertBytes(Number(size), 2)}</Typography>
      </TableCell>
      <TableCell sx={styles.tableCell}>
        <Typography>-</Typography>
      </TableCell>
      <TableCell sx={styles.tableCell} className="actions-wrapper">
        <RoundProgress value={percent} textSize={7} size={20} />
      </TableCell>
    </TableRow>
  );
};
